var render, staticRenderFns
import script from "./sub-campaign.vue?vue&type=script&lang=js"
export * from "./sub-campaign.vue?vue&type=script&lang=js"
import style0 from "./sub-campaign.vue?vue&type=style&index=0&id=3c6796b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6796b4",
  null
  
)

export default component.exports